import { render, staticRenderFns } from "./SharingSummaryReport.vue?vue&type=template&id=08997e70"
import script from "./SharingSummaryReport.vue?vue&type=script&lang=js"
export * from "./SharingSummaryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports